export default __webpack_public_path__ + "static/media/gist02.8bc186a6.jpg";